import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { MembershipOwnerComponent } from "../../../features/pages/services/membership/membership-owner/membership-owner.component";
import { SignatoriesListComponent } from "../../../features/pages/services/membership/manage-signatories/signatories-list/signatories-list.component";
import { CardListComponent } from "../card-list/card-list.component";
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-card-carousel',
  imports: [CommonModule, SignatoriesListComponent, CardListComponent, TranslateModule],
  templateUrl: './card-carousel.component.html',
  styleUrl: './card-carousel.component.scss'
})
export class CardCarouselComponent {
  @Input() ownerList: any[] = [];
  @Input() memberLabelOwnerPartnerList: any[] = [];  
  @Input() showActions = true;
  @Input() cardFor = "signatories";

  // Bubble the action from <app-membership-owner> up to parent
  @Output() onActionClick = new EventEmitter<any>();

  pages: any[][] = [];
  currentPage = 0;
  perView = 1;

  // This method is used to resize handler
  private resizeHandler = () => this.repaginate();

  // This method is used to handle the on init lifecycle hook
  ngOnInit(): void {
    this.perView = this.getPerView();
    this.repaginate();
    window.addEventListener('resize', this.resizeHandler);
  }

  // This method is used to handle the on changes lifecycle hook using changes
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['ownerList'] && !changes['ownerList'].firstChange) {
      this.repaginate();
    }
  }

  // This method is used to handle the on destroy lifecycle hook
  ngOnDestroy(): void {
    window.removeEventListener('resize', this.resizeHandler);
  }

  // navigation
  // This method is used to handle the next callback
  next() {
    if (this.currentPage < this.pages.length - 1) this.currentPage++;
  }
  // This method is used to return to the previous value
  prev() {
    if (this.currentPage > 0) this.currentPage--;
  }
  // This method is used to go to using i
  goTo(i: number) {
    if (i >= 0 && i < this.pages.length) this.currentPage = i;
  }

  // This method is used to track owner using  and owner
  trackOwner = (_: number, owner: any) => owner?.id ?? owner;

  // helpers
  // This method is used to get per view
  getPerView(): number {
    // 1 on mobile, 3 on >= sm (640px)
    return window.matchMedia('(min-width: 640px)').matches ? 3 : 1;
    
  }

  // This method is used to repaginate
  private repaginate(): void {
    const newPerView = this.getPerView();
    if (newPerView !== this.perView) this.perView = newPerView;

    const chunkSize = Math.max(1, this.perView);
    const arr = this.ownerList ?? [];
    const pages: any[][] = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
      pages.push(arr.slice(i, i + chunkSize));
    }
    this.pages = pages.length ? pages : [[]];
    this.currentPage = Math.min(this.currentPage, this.pages.length - 1);
    if (this.currentPage < 0) this.currentPage = 0;
  }
}
